"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleType = void 0;
var ModuleType;
(function (ModuleType) {
    ModuleType["API"] = "api";
    ModuleType["DEFAULT"] = "default";
})(ModuleType = exports.ModuleType || (exports.ModuleType = {}));
//# sourceMappingURL=ModuleType.js.map